import React from 'react';

function Money(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 6.5H1.5V18.5H22.5V6.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5 10.25C21.5631 10.0912 20.6989 9.64494 20.027 8.97304C19.3551 8.30113 18.9088 7.43686 18.75 6.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 18.5C18.9088 17.5631 19.3551 16.6989 20.027 16.027C20.6989 15.3551 21.5631 14.9088 22.5 14.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 14.75C2.43686 14.9088 3.30113 15.3551 3.97304 16.027C4.64494 16.6989 5.09121 17.5631 5.25 18.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 6.5C5.09121 7.43686 4.64494 8.30113 3.97304 8.97304C3.30113 9.64494 2.43686 10.0912 1.5 10.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Money;
